<template>
  <div class="card">
    <a v-if='linkURL' :href="linkURL" target="_blank">
      <img class="img-fluid" :src="require(`@/assets/${imageURL}`)" />
      <div class="card-footer"><slot></slot></div>
    </a>
    <router-link v-else
        :to="routerLink"
      >
      <img class="img-fluid" :src="require(`@/assets/${imageURL}`)" />
      <div class="card-footer"><slot></slot></div>
    </router-link>
  </div>
</template>

<script>
export default {
  name:'BaseCard',
  props:['imageURL','linkURL','routerLink']
}
</script>

<style lang='scss' scoped>
.card {
  margin: 16px 0px;
  box-shadow: 0 6px 6px rgba(0, 0, 0, 0.19), 0 2px 2px rgba(0, 0, 0, 0.23);
  border:none;
  .card-footer {
    background-color: $ruxRed;
  }
  a {
    color: #f7f7f7;
    text-transform: uppercase;
  }
  a:hover {
    text-decoration: none;
  }
}
</style>